import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import {sideProject} from '../../../src/profile'
import '../Projects/Projects.css'
import ProjectCard from '../Projects/ProjectCard'

function SideProject() {
     return (
        <div className='section-container'>
           <Header
                heading='My Personal Projects.'
                details="Here are some personal projects I've worked on, do check them out"
           /> 

           <div className='project-cards-container'>
          {sideProject.map(({projectName,started,projectDescription,imageUrl,projectUrl}) => {
              return (<ProjectCard 
                  projectName={projectName}
                  started={started}
                  projectDescription={projectDescription}
                  projectUrl={projectUrl}
                  imageUrl={imageUrl}
              />);
          })}
          </div>

            <Footer
                title='Check out my 👉 '
                link='Project!'
                toAdress='/projects'
        />
        </div>
    )
}

export default SideProject
